
import { useAuth } from '@/contexts/AuthContext';
import { useQuery } from '@tanstack/react-query';
import { fetchCourierRentals, createDemoRentals, showErrorToast } from '@/hooks/api/rentalService';
import { RentalInfo } from './types/rentalTypes';
import { useCourierInfo } from '@/pages/courier/hooks/useCourierInfo';

// Функция для получения данных аренд теперь использует реальный API из rentalService
export const useCourierRentals = () => {
  const { user } = useAuth();
  
  // Получаем правильный ID курьера из хука useCourierInfo
  const { courierId, loading: courierLoading } = useCourierInfo();
  
  console.log('useCourierRentals: используем courierId =', courierId);
  
  // Используем React Query для получения данных
  const { 
    data = { formattedRentals: [], error: null }, 
    isLoading, 
    error, 
    refetch 
  } = useQuery({
    queryKey: ['courierRentals', courierId],
    queryFn: async () => {
      if (!courierId) {
        console.log('useCourierRentals: нет ID курьера, возвращаем пустые данные');
        return { formattedRentals: [], error: null };
      }
      
      try {
        console.log('useCourierRentals: запрашиваем аренды для', courierId);
        const result = await fetchCourierRentals(courierId);
        
        console.log('useCourierRentals: получен результат', result);
        
        if (result.error) {
          // Если есть ошибка, показываем уведомление и используем тестовые данные
          showErrorToast(`Ошибка при загрузке аренд: ${result.error}`);
          console.error('Ошибка при получении аренд:', result.error);
          return { formattedRentals: createDemoRentals(), error: result.error };
        }
        
        return result;
      } catch (err: any) {
        console.error('Непредвиденная ошибка при получении аренд:', err);
        showErrorToast(`Непредвиденная ошибка: ${err.message}`);
        return { formattedRentals: createDemoRentals(), error: err.message };
      }
    },
    enabled: !!courierId && !courierLoading,
  });

  const rentals = data.formattedRentals || [];
  
  // Находим текущую активную аренду (если есть)
  const currentRental = Array.isArray(rentals) ? 
    rentals.find((rental: RentalInfo) => rental.status === 'active') || null : null;

  console.log('useCourierRentals: найдено аренд:', rentals.length, 
             'текущая аренда:', currentRental ? currentRental.id : 'отсутствует');

  return {
    rentals,
    currentRental,
    isLoading: isLoading || courierLoading,
    error: error || data.error,
    refetch
  };
};
